// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavbarDesktop_nav__84ApM","navItem":"NavbarDesktop_navItem__bbvAv","active":"NavbarDesktop_active__p4Za_","highlight":"NavbarDesktop_highlight__2FykJ"};